import { useQuery } from '@tanstack/react-query'
import type { Project } from '@one-deployment/api'
import { enc, get } from '@/lib/api'
import { useLiveQueryOpts } from '@/lib/live'
import { qk } from '@/lib/query'

export function useProject(project: string) {
  const live = useLiveQueryOpts(`project:${project}`)
  return useQuery({ queryKey: qk.project(project), queryFn: ({ signal }) => get<Project>(`/api/projects/${enc(project)}`, signal), ...live })
}

/** The PR on GitHub, built from the repo: the board carries only its number. */
export const prUrl = (p: Project | undefined, n: number) => (p ? `https://github.com/${p.repo.owner}/${p.repo.name}/pull/${n}` : undefined)
